import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonLibService } from '@lib/services';
import { CheckinBaseComponent } from '@common/components';
import { CHECKIN_ROUTES } from '@conf/routes.config';
import { CheckinCommonStoreService } from '@common/services/checkin-common-store/checkin-common-store.service';
import { PREVIOUS_PAGE_IDENTIFIER } from '@conf/previous-page-identifier.config';
import { ServicingMybookingTransitionService } from '@common/services';
import { ParameterToServicing, SITE_ID } from '@common/interface';
import { PostJourneysSearchJourneyRequest } from 'src/sdk_checkin';

@Component({
  selector: 'asw-checkin-select-sub-header',
  templateUrl: './checkin-select-sub-header.component.html',
  styleUrls: ['./checkin-select-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckinSelectSubHeaderComponent extends CheckinBaseComponent {
  /** 戻り先URL */
  backUrl = '';

  private previousPageIdentifier?: string;

  constructor(
    private common: CommonLibService,
    private checkinCommonStoreService: CheckinCommonStoreService,
    private servicingMybookingTransitionService: ServicingMybookingTransitionService
  ) {
    super(common);
  }

  override reload(): void {}
  override init(): void {
    this.previousPageIdentifier = this.checkinCommonStoreService.checkinCommon.previousPageIdentifier;
    switch (this.previousPageIdentifier) {
      case PREVIOUS_PAGE_IDENTIFIER.CHECKIN_STATUS:
        this.backUrl = CHECKIN_ROUTES.checkinMybooking;
        break;
      case PREVIOUS_PAGE_IDENTIFIER.SERVICING_MY_BOOKING:
        this.backUrl = this.servicingMybookingTransitionService.getServicingPathWithConnectionKind();
        break;
      default:
        this.backUrl = CHECKIN_ROUTES.checkinSearch;
        break;
    }
  }

  /**
   * 戻るボタンが押下された場合イベント(予約詳細への遷移の場合のみ)
   * @param event
   */
  onClickBackButton(event: Event) {
    this.updatePreviousPageIdentifier();
    event.preventDefault();

    const params: ParameterToServicing = {
      firstName: this.common.aswServiceStoreService.aswServiceData.firstName,
      lastName: this.common.aswServiceStoreService.aswServiceData.lastName,
      SITE_ID: SITE_ID.ASW_APP,
    };

    // 検索条件が予約番号か、搭乗券番号かでパラメータの切り分け
    if (
      this.checkinCommonStoreService.checkinCommon.searchType === PostJourneysSearchJourneyRequest.SearchTypeEnum.Order
    ) {
      Object.assign(params, {
        searchType: PostJourneysSearchJourneyRequest.SearchTypeEnum.Order,
        orderId: this.common.aswServiceStoreService.aswServiceData.orderId,
      });
    } else {
      Object.assign(params, {
        searchType: PostJourneysSearchJourneyRequest.SearchTypeEnum.ETicket,
        eTicketNumber: this.common.aswServiceStoreService.aswServiceData.travelDocumentId,
      });
    }

    this.servicingMybookingTransitionService.transitionToServicing(params);
  }

  /**
   * 予約詳細からの遷移か判定する
   * @returns 前画面IDがPREVIOUS_PAGE_IDENTIFIER.SERVICING_MY_BOOKINGと等しければtrue、そうでなければfalse
   */
  isFromServicingMybooking() {
    return this.previousPageIdentifier && this.previousPageIdentifier === PREVIOUS_PAGE_IDENTIFIER.SERVICING_MY_BOOKING;
  }

  /** 前画面IDをチェックイン対象選択に設定する */
  updatePreviousPageIdentifier() {
    this.checkinCommonStoreService.updateCheckinCommon({
      previousPageIdentifier: PREVIOUS_PAGE_IDENTIFIER.CHECKIN_SELECT,
    });
  }

  override destroy(): void {}
}
